

































































import {Component, Vue} from 'vue-property-decorator'

@Component
export default class OrbitInsufficientGasStep extends Vue {
  get neoLink() {
    return this.$translate('components.OrbitInsufficientGasStep.neoLink')
  }
}
